import * as yup from 'yup'

let contactSchema = yup.object().shape({
  firstName: yup.string().required('*Required'),
  lastName: yup.string().required('*Required'),
  email: yup
    .string()
    .email('*Email must be a valid email')
    .required('*Required'),
  phone: yup.string().required('*Required'),
  subject: yup.string().notOneOf(['']).required('*Required'),
  message: yup.string().required('*Required')
})

export default contactSchema
